import React from 'react';

function buildViewAttrs({
  productId,
  productIds,
  categoryId,
  categoryIds,
  tag,
  sourceLocation,
  context,
  origin,
  activityEndpoint,
  userType,
  distinctId,
}) {
  const payload = { sourceLocation, context };
  const attrs = {
    'data-buyer-intent': JSON.stringify(payload),
    'data-origin': origin,
    'data-activity-endpoint': activityEndpoint,
    'data-user-type': userType,
    'data-distinct-id': distinctId,
  };

  if (tag) attrs.tag = tag;
  if (sourceLocation) attrs['source-location'] = sourceLocation;
  if (productId != null) attrs['product-id'] = String(productId);
  if (productIds) attrs['product-ids'] = JSON.stringify(productIds);
  if (categoryId != null) attrs['category-id'] = String(categoryId);
  if (categoryIds) attrs['category-ids'] = JSON.stringify(categoryIds);

  return attrs;
}

function buildClickAttrs({
  eventName,
  productId,
  productIds,
  categoryId,
  categoryIds,
  sourceLocation,
  context,
  origin,
  activityEndpoint,
  userType,
  distinctId,
}) {
  const payload = { sourceLocation, context };
  const attrs = {
    'data-buyer-intent': JSON.stringify(payload),
    'data-origin': origin,
    'data-activity-endpoint': activityEndpoint,
    'data-user-type': userType,
    'data-distinct-id': distinctId,
  };

  if (eventName) attrs['event-name'] = eventName;
  if (productId != null) attrs['product-id'] = String(productId);
  if (productIds) attrs['product-ids'] = JSON.stringify(productIds);
  if (categoryId != null) attrs['category-id'] = String(categoryId);
  if (categoryIds) attrs['category-ids'] = JSON.stringify(categoryIds);

  return attrs;
}

export function SessionProvider({
  origin,
  activityEndpoint,
  userType,
  distinctId,
  children,
}) {
  const attrs = {};
  if (origin) attrs.origin = origin;
  if (activityEndpoint) attrs['activity-endpoint'] = activityEndpoint;
  if (userType) attrs['user-type'] = userType;
  if (distinctId) attrs['distinct-id'] = distinctId;
  return React.createElement('buyer-intent-session', attrs, children);
}

export function SubjectTracker({
  productId,
  categoryId,
  productIds,
  categoryIds,
}) {
  const attrs = {};
  if (productId != null) attrs['product-id'] = String(productId);
  if (categoryId != null) attrs['category-id'] = String(categoryId);
  if (productIds) attrs['product-ids'] = JSON.stringify(productIds);
  if (categoryIds) attrs['category-ids'] = JSON.stringify(categoryIds);
  return React.createElement('buyer-intent-subject', attrs);
}

export function ViewTracker({ children, ...rest }) {
  return React.createElement(
    'buyer-intent-view',
    buildViewAttrs(rest),
    children
  );
}

export function ClickTracker({ children, ...rest }) {
  return React.createElement(
    'buyer-intent-click',
    buildClickAttrs(rest),
    children
  );
}
